// extracted by mini-css-extract-plugin
export default {"containerArea":"TextAreaInput_containerArea__7s-WD","textarea":"TextAreaInput_textarea__ic2Ss","error":"TextAreaInput_error__Q5S6g","symbols":"TextAreaInput_symbols__nF5ul"};